var map = {
	"./white/0.25.svg": 791,
	"./white/0.5.svg": 792,
	"./white/0.75.svg": 793,
	"./white/0.svg": 794,
	"./white/1.svg": 795,
	"./white/10.svg": 796,
	"./white/11.svg": 797,
	"./white/2.svg": 798,
	"./white/3.svg": 799,
	"./white/4.svg": 800,
	"./white/5.svg": 801,
	"./white/6.svg": 802,
	"./white/7.svg": 803,
	"./white/8.svg": 804,
	"./white/9.svg": 805,
	"./yellow/0.25.svg": 806,
	"./yellow/0.5.svg": 807,
	"./yellow/0.75.svg": 808,
	"./yellow/0.svg": 809,
	"./yellow/1.svg": 810,
	"./yellow/10.svg": 811,
	"./yellow/11.svg": 812,
	"./yellow/2.svg": 813,
	"./yellow/3.svg": 814,
	"./yellow/4.svg": 815,
	"./yellow/5.svg": 816,
	"./yellow/6.svg": 817,
	"./yellow/7.svg": 818,
	"./yellow/8.svg": 819,
	"./yellow/9.svg": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 790;